export const fetcher = (...args) =>
  fetch(...args).then((res) => {
    // console.log("call");
    return res.json();
  });
